import { AxiosError } from 'axios';

import { SkyMapAxiosServiceFactory } from '../../../../../../services/axios/skymap-axios-service-factory';
import { DonglesIntegrationItem } from '../../../state/integrations-state';
import { IDeleteIntegrationDialogItemService } from './types';

export class DeleteIntegrationDialogDongleService implements IDeleteIntegrationDialogItemService {
  constructor(private item: DonglesIntegrationItem) {}

  async deleteIntegration() {
    const projectService = SkyMapAxiosServiceFactory.instance.createProjectServiceV1();
    try {
      await projectService.deleteAllAttachedDongles({ path: { projectId: this.item.projectId } });
    } catch (error) {
      if ((error as AxiosError).response?.status !== 404) {
        throw error;
      }
    }
  }
}
